<div class="seating-chart">
    <h3 class="title">{{seatingChart.title}}</h3>
    <div class="copy">{{seatingChart.copy}}</div>
    <div class="seating">
        <table class="chart" role="grid">
            <thead role="rowgroup">
                <tr role="row">
                    <ng-container *ngFor="let title of seatingChart.chart.header; let i = index">
                        <th
                            *ngIf="title; else noTitle"
                            id="seating-chart-column-{{i}}"
                            scope="col" role="columnheader"
                            [attr.aria-label]="title" >
                                {{title}}
                        </th>
                        <ng-template #noTitle>
                            <td></td>
                        </ng-template>
                    </ng-container>
                </tr>
            </thead>
            <tbody role="rowgroup">
                <tr *ngFor="let row of seatingChart.chart.rows; let i = index" role="row">
                    <ng-container *ngFor="let cell of row; let j = index; first as isFirst">
                        <th
                            *ngIf="isFirst; else tdCell"
                            scope="row"
                            role="rowheader"
                            [ngClass]="cell.class">
                                {{cell.text}}
                        </th>
                        <ng-template #tdCell>
                            <td
                                [ngClass]="cell.class"
                                role="gridcell"
                                [attr.aria-labelledby]="'seating-chart-column-'+j">
                                    {{cell.text}}
                                    <finder-icon-tooltip
                                        *ngIf="cell.toolTip"
                                        id="seating-tooltip-{{i}}-{{j}}"
                                        [name]="'learn-more'"
                                        [size]="'xs'"
                                        [title]="getToolTipModalId(cell.text + '-' + i)"
                                        [tooltip]="cell.toolTip"
                                        [position]="'top-right'">
                                    </finder-icon-tooltip>
                            </td>
                        </ng-template>
                    </ng-container>
                </tr>
            </tbody>
        </table>
        <finder-picture [picture]="seatingChart.image"></finder-picture>
    </div>
    <p class="disclaimer">{{seatingChart.copy}}</p>
</div>
